import ActivitiesWorker from '@/filters/activitiesWorker?worker'
import CarsWorker from '@/filters/carsWorker?worker'
import CruisesWorker from '@/filters/cruisesWorker?worker'
import ExtraServicesWorker from '@/filters/extraServicesWorker?worker'
import FlightsWorker from '@/filters/flightsWorker?worker'
import HotelsWorker from '@/filters/hotelsWorker?worker'
import InsuranceWorker from '@/filters/insuranceWorker?worker'
import VisaWorker from '@/filters/visaWorker?worker'
import PackagesWorker from '@/filters/packagesWorker?worker'
import ToursWorker from '@/filters/toursWorker?worker'
import TransfersWorker from '@/filters/transfersWorker?worker'
import SimpleToursWorker from '@/filters/simpleToursWorker?worker'

export default defineNuxtPlugin(() => {
    return {
        provide: {
            workers: {
                activitiesWorker: new ActivitiesWorker(),
                carsRentWorker: new CarsWorker(),
                cruisesWorker: new CruisesWorker(),
                extraServicesWorker: new ExtraServicesWorker(),
                flightsWorker: new FlightsWorker(),
                hotelsWorker: new HotelsWorker(),
                insuranceWorker: new InsuranceWorker(),
                visaWorker: new VisaWorker(),
                packagesWorker: new PackagesWorker(),
                toursWorker: new ToursWorker(),
                transfersWorker: new TransfersWorker(),
                simpleToursWorker: new SimpleToursWorker(),
            },
        },
    }
})
